module.exports = __webpack_public_path__ + "img/1-1.d4e2be1e.png";